namespace RioERP.Inventory {
    export namespace PermissionKeys {
        export const General = "Inventory:General";

        namespace InventoryManagement {
            export const Delete = "Inventory:InventoryManagement:Delete";
            export const Modify = "Inventory:InventoryManagement:Modify";
            export const View = "Inventory:InventoryManagement:View";
        }
    }
}
